import { type Activation, api, queryKeys } from '@alpha/api-client';
import { useQuery } from '@tanstack/react-query';
import { createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';
import { DataTable } from '../../components/DataTable';
import { PageHeader } from '../../components/PageHeader';
import { useTableQuery } from '../../hooks/useTableQuery';
import { formatDateTime, formatLds, formatUsd } from '../../lib/format';
import { Chip } from '../../ui';
import { PACKAGE_TABS } from './Activate';

const col = createColumnHelper<Activation>();

export function ActivationHistory() {
  const { query, setPage } = useTableQuery();

  const { data, isLoading, error } = useQuery({
    queryKey: queryKeys.activations(query),
    queryFn: () => api.activations.history(query),
  });

  const columns = useMemo(
    () => [
      col.accessor('package_name', { header: 'Package' }),
      col.accessor('amount_usd', { header: 'USD', cell: (i) => formatUsd(i.getValue()) }),
      col.accessor('amount_lds', { header: 'LDS', cell: (i) => formatLds(i.getValue()) }),
      col.accessor('source', { header: 'Source', cell: (i) => <Chip tone="info">{i.getValue()}</Chip> }),
      col.accessor('tx_hash', {
        header: 'Tx Hash',
        cell: (i) => (i.getValue() ? `${i.getValue()!.slice(0, 12)}…` : '—'),
      }),
      col.accessor('activated_at', { header: 'Activated', cell: (i) => formatDateTime(i.getValue()) }),
    ],
    [],
  );

  return (
    <>
      <PageHeader title="Activation History" tabs={PACKAGE_TABS} />
      <DataTable<Activation>
        title="Activations"
        columns={columns}
        data={data?.data}
        meta={data?.meta}
        isLoading={isLoading}
        error={error as Error | null}
        onPageChange={setPage}
      />
    </>
  );
}
